import { createContext, useContext, useState, useCallback } from "react";

const translations = {
  fr: {
    // Header
    tagline: "Transcription & Traduction IA",
    // Hero
    heroTitle1: "Transforme tes audios en",
    heroTitle2: "contenu prêt à publier",
    heroDesc: "Transcris, traduis et génère automatiquement des articles, emails et posts LinkedIn à partir de n'importe quel audio.",
    // Upload
    dropText: "Glissez-déposez votre fichier ici",
    dropFormats: "Tous formats audio/vidéo (max 50MB)",
    orPasteLink: "Ou collez un lien",
    linkPlaceholder: "Lien direct vers un fichier audio ou vidéo...",
    processLink: "Traiter le lien",
    // Controls
    sourceLang: "Langue source",
    autoDetect: "Détection automatique",
    targetLang: "Langue cible",
    summary: "Résumé",
    // CTA
    ctaButton: "Transcrire et traduire",
    // Loading
    analyzing: "Analyse en cours...",
    preparing: "Préparation...",
    transcribing: "Transcription en cours...",
    translating: "Traduction en cours...",
    summarizing: "Génération du résumé...",
    downloading: "Téléchargement de l'audio...",
    processing: "Traitement...",
    // Results
    detectedLang: "Langue détectée",
    transcription: "Transcription",
    translation: "Traduction",
    improve: "Améliorer",
    improved: "Amélioré",
    original: "Original",
    copy: "Copier",
    copied: "Copié",
    download: "Télécharger",
    // Actions
    smartResult: "Résultat intelligent",
    generateContent: "Générer du contenu",
    generateAll: "Tout générer",
    summaryShort: "Résumé",
    keyPoints: "Points clés",
    structuredPlan: "Plan structuré",
    article: "Article",
    email: "Email",
    linkedinPost: "Post LinkedIn",
    newTranslation: "Nouvelle traduction",
    // Toasts
    toastProcessed: "Traitement terminé !",
    toastCopied: "Texte copié !",
    toastDownloaded: "Fichier téléchargé !",
    toastImproved: "Texte amélioré !",
    toastGenerated: "Contenu généré !",
    toastAllGenerated: "Tous les contenus générés !",
    toastSrt: "Sous-titres SRT téléchargés !",
    toastSummaryCopied: "Résumé copié !",
    toastContentCopied: "Contenu copié !",
    toastError: "Erreur lors du traitement",
    toastNoFile: "Veuillez sélectionner un fichier audio",
    toastBadFormat: "Format non supporté.",
    toastTooBig: "Fichier trop volumineux. Maximum : 50MB.",
    toastNoLink: "Veuillez entrer un lien valide",
    // Tab
    tabFile: "Fichier",
    tabLink: "Lien",
  },
  en: {
    tagline: "AI Transcription & Translation",
    heroTitle1: "Turn your audio into",
    heroTitle2: "ready-to-publish content",
    heroDesc: "Transcribe, translate and automatically generate articles, emails and LinkedIn posts from any audio.",
    dropText: "Drag & drop your file here",
    dropFormats: "All audio/video formats (max 50MB)",
    orPasteLink: "Or paste a link",
    linkPlaceholder: "Direct link to an audio or video file...",
    processLink: "Process link",
    sourceLang: "Source language",
    autoDetect: "Auto-detect",
    targetLang: "Target language",
    summary: "Summary",
    ctaButton: "Transcribe & translate",
    analyzing: "Analyzing...",
    preparing: "Preparing...",
    transcribing: "Transcribing...",
    translating: "Translating...",
    summarizing: "Generating summary...",
    downloading: "Downloading audio...",
    processing: "Processing...",
    detectedLang: "Detected language",
    transcription: "Transcription",
    translation: "Translation",
    improve: "Improve",
    improved: "Improved",
    original: "Original",
    copy: "Copy",
    copied: "Copied",
    download: "Download",
    smartResult: "Smart result",
    generateContent: "Generate content",
    generateAll: "Generate all",
    summaryShort: "Summary",
    keyPoints: "Key points",
    structuredPlan: "Structured plan",
    article: "Article",
    email: "Email",
    linkedinPost: "LinkedIn Post",
    newTranslation: "New translation",
    toastProcessed: "Processing complete!",
    toastCopied: "Text copied!",
    toastDownloaded: "File downloaded!",
    toastImproved: "Text improved!",
    toastGenerated: "Content generated!",
    toastAllGenerated: "All content generated!",
    toastSrt: "SRT subtitles downloaded!",
    toastSummaryCopied: "Summary copied!",
    toastContentCopied: "Content copied!",
    toastError: "Processing error",
    toastNoFile: "Please select an audio file",
    toastBadFormat: "Unsupported format.",
    toastTooBig: "File too large. Maximum: 50MB.",
    toastNoLink: "Please enter a valid link",
    tabFile: "File",
    tabLink: "Link",
  },
  ar: {
    tagline: "النسخ والترجمة بالذكاء الاصطناعي",
    heroTitle1: "حوّل أي صوت إلى",
    heroTitle2: "محتوى جاهز للاستخدام",
    heroDesc: "صوت واحد = نسخ + ترجمة + ملخص + مقال + بريد + منشور لينكد إن. في ثوانٍ.",
    dropText: "اسحب وأفلت ملفك هنا",
    dropFormats: "جميع صيغ الصوت/الفيديو (حد أقصى 50 ميجا)",
    orPasteLink: "أو الصق رابطاً",
    linkPlaceholder: "رابط مباشر لملف صوتي أو مرئي...",
    processLink: "معالجة الرابط",
    sourceLang: "لغة المصدر",
    autoDetect: "كشف تلقائي",
    targetLang: "اللغة المستهدفة",
    summary: "ملخص",
    ctaButton: "نسخ وترجمة",
    analyzing: "جاري التحليل...",
    preparing: "جاري التحضير...",
    transcribing: "جاري النسخ...",
    translating: "جاري الترجمة...",
    summarizing: "جاري إنشاء الملخص...",
    downloading: "جاري تحميل الصوت...",
    processing: "جاري المعالجة...",
    detectedLang: "اللغة المكتشفة",
    transcription: "النسخ",
    translation: "الترجمة",
    improve: "تحسين",
    improved: "محسّن",
    original: "الأصلي",
    copy: "نسخ",
    copied: "تم النسخ",
    download: "تحميل",
    smartResult: "نتيجة ذكية",
    generateContent: "إنشاء محتوى",
    generateAll: "إنشاء الكل",
    summaryShort: "ملخص",
    keyPoints: "نقاط رئيسية",
    structuredPlan: "خطة منظمة",
    article: "مقال",
    email: "بريد إلكتروني",
    linkedinPost: "منشور لينكد إن",
    newTranslation: "ترجمة جديدة",
    toastProcessed: "اكتملت المعالجة!",
    toastCopied: "تم نسخ النص!",
    toastDownloaded: "تم تحميل الملف!",
    toastImproved: "تم تحسين النص!",
    toastGenerated: "تم إنشاء المحتوى!",
    toastAllGenerated: "تم إنشاء جميع المحتويات!",
    toastSrt: "تم تحميل ترجمات SRT!",
    toastSummaryCopied: "تم نسخ الملخص!",
    toastContentCopied: "تم نسخ المحتوى!",
    toastError: "خطأ في المعالجة",
    toastNoFile: "يرجى اختيار ملف صوتي",
    toastBadFormat: "صيغة غير مدعومة.",
    toastTooBig: "الملف كبير جداً. الحد الأقصى: 50 ميجا.",
    toastNoLink: "يرجى إدخال رابط صالح",
    tabFile: "ملف",
    tabLink: "رابط",
  },
  es: {
    tagline: "Transcripcion & Traduccion IA",
    heroTitle1: "Transforma tu audio en",
    heroTitle2: "contenido listo para publicar",
    heroDesc: "Transcribe, traduce y genera automáticamente artículos, emails y posts de LinkedIn a partir de cualquier audio.",
    dropText: "Arrastra y suelta tu archivo aqui",
    dropFormats: "Todos los formatos de audio/video (max 50MB)",
    orPasteLink: "O pega un enlace",
    linkPlaceholder: "Enlace directo a un archivo de audio o video...",
    processLink: "Procesar enlace",
    sourceLang: "Idioma fuente",
    autoDetect: "Deteccion automatica",
    targetLang: "Idioma destino",
    summary: "Resumen",
    ctaButton: "Transcribir y traducir",
    analyzing: "Analizando...",
    preparing: "Preparando...",
    transcribing: "Transcribiendo...",
    translating: "Traduciendo...",
    summarizing: "Generando resumen...",
    downloading: "Descargando audio...",
    processing: "Procesando...",
    detectedLang: "Idioma detectado",
    transcription: "Transcripcion",
    translation: "Traduccion",
    improve: "Mejorar",
    improved: "Mejorado",
    original: "Original",
    copy: "Copiar",
    copied: "Copiado",
    download: "Descargar",
    smartResult: "Resultado inteligente",
    generateContent: "Generar contenido",
    generateAll: "Generar todo",
    summaryShort: "Resumen",
    keyPoints: "Puntos clave",
    structuredPlan: "Plan estructurado",
    article: "Articulo",
    email: "Email",
    linkedinPost: "Post LinkedIn",
    newTranslation: "Nueva traduccion",
    toastProcessed: "Procesamiento completado!",
    toastCopied: "Texto copiado!",
    toastDownloaded: "Archivo descargado!",
    toastImproved: "Texto mejorado!",
    toastGenerated: "Contenido generado!",
    toastAllGenerated: "Todo el contenido generado!",
    toastSrt: "Subtitulos SRT descargados!",
    toastSummaryCopied: "Resumen copiado!",
    toastContentCopied: "Contenido copiado!",
    toastError: "Error de procesamiento",
    toastNoFile: "Por favor selecciona un archivo de audio",
    toastBadFormat: "Formato no soportado.",
    toastTooBig: "Archivo demasiado grande. Maximo: 50MB.",
    toastNoLink: "Por favor ingresa un enlace valido",
    tabFile: "Archivo",
    tabLink: "Enlace",
  },
};

const SITE_LANGUAGES = [
  { code: "fr", name: "Francais" },
  { code: "en", name: "English" },
  { code: "ar", name: "العربية" },
  { code: "es", name: "Espanol" },
];

const I18nContext = createContext();

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    try {
      return localStorage.getItem("vt_locale") || "fr";
    } catch {
      return "fr";
    }
  });

  const changeLocale = useCallback((newLocale) => {
    setLocale(newLocale);
    try { localStorage.setItem("vt_locale", newLocale); } catch {}
  }, []);

  const t = useCallback((key) => {
    return translations[locale]?.[key] || translations.fr[key] || key;
  }, [locale]);

  const isRtl = locale === "ar";

  return (
    <I18nContext.Provider value={{ locale, changeLocale, t, isRtl, SITE_LANGUAGES }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
